import { Box, Flex, Grid, Heading, Text } from "@radix-ui/themes";
import type { LiveSeoContent as LiveSeoPageData } from "~/data/liveSeoContent.functions";
import { HeroStyle2 } from "~/components/HeroStyle2";
import { LinkCta } from "~/components/LinkCta";
import styles from "./live-seo-page.module.css";

export function DefaultLiveSeoPage({ page }: { page: LiveSeoPageData }) {
	const paragraphs = page.paragraphs.filter(
		(paragraph) => !/All Rights Reserved/i.test(paragraph),
	);
	const heroImageUrl = page.image?.src ?? "/hero-bg.jpg";

	return (
		<Flex direction="column">
			<HeroStyle2
				heroImageUrl={heroImageUrl}
				title={page.h1 || page.title}
				backgroundPosition="center"
			/>
			<Box className={styles.contentBand}>
				<Flex className={styles.inner} direction="column" gap="7">
					{paragraphs.length > 0 ? (
						<Flex direction="column" gap="4" className={styles.copy}>
							{paragraphs.map((paragraph) => (
								<Text as="p" size="4" key={paragraph}>
									{paragraph}
								</Text>
							))}
						</Flex>
					) : null}

					{page.h2s.length > 0 ? (
						<Grid
							columns={{ initial: "1", sm: "2" }}
							gap="4"
							className={styles.topicGrid}
						>
							{page.h2s.map((heading) => (
								<Heading as="h2" size="5" key={heading}>
									{heading}
								</Heading>
							))}
						</Grid>
					) : null}

					<Box className={styles.ctaWrap}>
						<LinkCta to="/free-consult" px="6" py="4">
							Free Consult
						</LinkCta>
					</Box>
				</Flex>
			</Box>
		</Flex>
	);
}
